const getGroupStatus = (groupId, defaultStatus = 'PENDING') => {
  return localStorage.getItem(`merge_status_${groupId}`) || defaultStatus;
};
// 🔹 Dummy data (replace with API)
export const getDummyGroups = () => [
  {
    id: '1',
    group: 'Group1',
    first: 'c  ',
    last: 'davis',
    address: '1 stratford pl',
    city: 'ormond beach',
    province: 'fl',
    postal: '32174',
    phone: '',
    email: '',
    account: '',
    source_file: 'STARS',
    file: 'input',
  },
  {
    id: '2',
    group: 'Group1',
    first: 'chris',
    last: 'davis',
    address: '1 stratford pl',
    city: 'ormond beach',
    province: 'fl',
    postal: '32174',
    phone: '',
    email: 'chris.davis@ford.com',
    account: '',
    source_file: 'SPS',
    file: 'input',
  },
  {
    id: '3',
    group: 'Group1',
    first: 'chris',
    last: 'davis',
    address: '1 stratford pl',
    city: 'ormond beach',
    province: 'fl',
    postal: '32174',
    phone: '',
    email: 'chris.davis@ford.com',
    account: '',
    source_file: 'STARS',
    file: 'history',
  },
  {
    id: '4',
    group: 'Group2',
    first: 'jen',
    last: 'medina',
    address: '11870 sw 12th pl',
    city: 'davie',
    province: 'fl',
    postal: '33325',
    phone: '',
    email: '',
    account: '',
    source_file: 'STARS',
    file: 'input',
  },
  {
    id: '5',
    group: 'Group2',
    first: 'jennifer',
    last: 'medina',
    address: '11870 sw 12th pl',
    city: 'davie',
    province: 'fl',
    postal: '33325',
    phone: '9546829316',
    email: 'jmedina2677@gmail.com',
    account: '',
    source_file: 'STARS',
    file: 'input',
  },
  {
    id: '6',
    group: 'Group2',
    first: 'jennifer',
    last: 'medina',
    address: '11870 sw 12th pl',
    city: 'davie',
    province: 'fl',
    postal: '33325',
    phone: '9546829316',
    email: 'jmedina2677@gmail.com',
    account: '',
    source_file: 'SPS',
    file: 'input',
  },
  {
    id: '7',
    group: 'Group3',
    first: 'collin',
    last: 'ostrand',
    address: '',
    city: 'FREMONT',
    province: 'NE',
    postal: '68025',
    phone: '',
    email: 'collin.ostrand@ford.com',
    account: '',
    source_file: 'STARS',
    file: 'input',
  },
  {
    id: '8',
    group: 'Group3',
    first: 'collin',
    last: 'ostrand',
    address: '',
    city: 'FREMONT',
    province: 'NE',
    postal: '68025',
    phone: '',
    email: 'collin.ostrand@ford.com',
    account: '',
    source_file: 'SPS',
    file: 'history',
  },
  {
    id: '9',
    group: 'Group4',
    first: 'shane',
    last: 'hudson',
    address: '1110062ndaveapt208b',
    city: 'SEMINOLE',
    province: 'FL',
    postal: '33772',
    phone: '',
    email: 'shane.hudson@ford.com',
    account: '',
    source_file: 'SPS',
    file: 'history',
  },
  {
    id: '10',
    group: 'Group4',
    first: 'shane',
    last: 'hudson',
    address: '1110062ndaveapt208b',
    city: 'SEMINOLE',
    province: 'FL',
    postal: '33772',
    phone: '',
    email: 'shane.hudson@ford.com',
    account: '',
    source_file: 'STARS',
    file: 'history',
  },
  {
    id: '11',
    group: 'Group4',
    first: 'shane',
    last: 'bing',
    address: '1110062ndaveapt208b',
    city: 'SEMINOLE',
    province: 'FL',
    postal: '33772',
    phone: '',
    email: '',
    account: '',
    source_file: 'SPS',
    file: 'input',
  },
  {
    id: '12',
    group: 'Group4',
    first: 'shane',
    last: 'bing',
    address: '1110062ndaveapt208b',
    city: 'SEMINOLE',
    province: 'FL',
    postal: '33772',
    phone: '',
    email: 'shane.hudson@ford.com',
    account: '',
    source_file: 'SPS',
    file: 'input',
  },
];
